export const FIELD_INFO = {
    name: {
        minLength: 1,
        maxLength: 255,
    },
    description: {
        minLength: 0,
        maxLength: 25000,
    },
    maxImages: 7,
    maxImagesLevel: 'product',
    isCategoryRequired: true,
} as const
